import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAgent } from '../../../models/agents.models';

@Component({
  selector: 'app-new-agent-catalogs',
  templateUrl: './new-agent-catalogs.component.html',
  styleUrls: ['./new-agent-catalogs.component.scss'],
})
export class NewAgentCatalogsComponent implements OnInit {
  @Input() agent!: IAgent;
  @Output() nextStep = new EventEmitter();
  @Output() previousStep = new EventEmitter();

  selectedCatalogs: number[] = [];
  disclaimerActive: boolean = true;

  constructor() {}

  async ngOnInit(): Promise<void> {
    if (this.agent && this.agent.pricelist_ids)
      this.selectedCatalogs = this.agent.pricelist_ids as number[];
  }

  selectedCatalogsChange(catalogs: number[]) {
    this.selectedCatalogs = catalogs;
  }

  next(options: { skip: boolean } = { skip: false }) {
    this.nextStep.emit(
      options.skip
        ? { pricelist_ids: [] }
        : { pricelist_ids: this.selectedCatalogs }
    );
  }

  previous() {
    this.previousStep.emit({ pricelist_ids: this.selectedCatalogs });
  }
}
